import CalendarTimeIcon from "@svg/course/release-steps/CalendarTime";
import CameraVideoIcon from "@svg/course/release-steps/CameraVideo";
import CheckCircleIcon from "@svg/course/release-steps/CheckCircle";
import MovieReelIcon from "@svg/course/release-steps/MovieReel";
import PlanningIcon from "@svg/course/release-steps/Planning";
import QualityControlIcon from "@svg/course/release-steps/QualityControl";
import { FC, Fragment } from "react";
import ReleaseStep from "./ReleaseStep";
import ProductReleaseStepsMiddleDiviver from "@svg/course/release-steps/MiddleDivider";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import MobileProductReleaseSteps from "./MobileReleaseSteps";
import { STATUS } from "@types";
import { useAccess } from "@templates/course/hooks/useAccess";
import StepDivider from "assets/patterns/StepDivider";

const iconClassName = "w-5    h-5    md:w-8   md:h-8";
const stepsTop = [
  {
    title: "برنامه‌ریزی اولیه",
    icon: <PlanningIcon className={iconClassName} />,
    status: STATUS.PLANNING,
  },
  {
    title: "هماهنگی شروع ضبط",
    icon: <CalendarTimeIcon className={iconClassName} />,
    status: STATUS.START_RECORDING,
  },
  {
    title: "ضبط آموزش",
    icon: <CameraVideoIcon className={iconClassName} />,
    status: STATUS.RECORDING,
  },
];
const stepsBottom = [
  {
    title: "ویرایش و تدوین",
    icon: <MovieReelIcon className={iconClassName} />,
    status: STATUS.EDITING,
  },
  {
    title: "کنترل کیفیت",
    icon: <QualityControlIcon className={iconClassName} />,
    status: STATUS.QUALITY_INSPECTION,
  },
  {
    title: "نشر نهایی",
    icon: <CheckCircleIcon className={iconClassName} />,
    status: STATUS.PUBLISHING,
  },
];
export const allReleasingSteps = [...stepsTop, ...stepsBottom];

const ProductReleaseSteps: FC = () => {
  const isMobile = useIsMobile();
  const { courseData } = useAccess();
  const {
    product: { status },
  } = courseData;

  const activeStep =
    allReleasingSteps.findIndex((f) => f.status === status) || 0;

  if (isMobile) return <MobileProductReleaseSteps activeStep={activeStep} />;
  return (
    <div>
      <div className="flex flex-col md:flex-row gap-5    w-full items-center">
        {stepsTop.map((step, i) => {
          const isDone = i <= activeStep;
          const isActive = i === activeStep;
          return (
            <Fragment key={i}>
              {i > 0 && (
                <div className="grow">
                  <StepDivider />
                </div>
              )}
              <ReleaseStep {...{ isActive, isDone, step }} />
            </Fragment>
          );
        })}
      </div>
      <div className="w-full px-2.5   relative items-center hidden md:flex ">
        {/* <SparklingIcon className="absolute right-2/3" /> */}
        <ProductReleaseStepsMiddleDiviver className="w-full" />
      </div>
      <div className="flex flex-col md:flex-row gap-5    w-full items-center">
        {stepsBottom.map((step, i) => {
          const itemIndex = i + 3;
          const isDone = itemIndex <= activeStep;
          const isActive = itemIndex === activeStep;
          return (
            <Fragment key={i}>
              {i > 0 && (
                <div className="grow">
                  <StepDivider />
                </div>
              )}
              <ReleaseStep {...{ isActive, isDone, step }} />
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProductReleaseSteps;
